<script>
    import workspaceService from '../../../services/workspace.js';
    import { goto } from '@roxi/routify';
    import { format } from 'svelte-i18n';

    let queryString = new URLSearchParams(document.location.search.substring(1));
    let token = queryString.get('token');
    let success = false;

    let error;

    let processing = true;

    if(!token){
      $goto("/login");
    }
    else {
      workspaceService.deny(token)
        .then((response)=>{
          if(response.ok){
            success = true;
          }
          else{
            if(response.status == 403){
              error = 'Token inválido'
            }
            if(response.status == 404){
              error = 'Token ya utilizado'
            }
          }
          processing = false;
        })
      ;
    }
  </script>

<section class="col-12">
	<div
		class="pt-5 pb-5 w-100 text-center"
		style="display: flex; flex-direction: column; align-content: center; align-items: center; justify-content: center;"
	>
		<div class="col-12 col-sm-6 text-center card pb-5">
			{#if processing}
				<div
					class="overlay text-center d-flex flex-column align-items-center pt-5 pb-5"
				>
					<i class="fas fa-2x fa-sync-alt fa-spin" />
				</div>
			{:else if !success && !processing}
				<div class="card-header vlsk-red">
					<strong>Error</strong>
				</div>
				<div class="card-body w-100 pt-5 pb-5 text-center">
					{error}
				</div>
			{:else}
				<div class="card-header text-center">
					<img
						src="/img/logo-vulseek-red-with-legend.png"
						alt="Vulseek by Securetia"
						class="brand-image logo-img logo-img-login"
					/>
				</div>
				<div class="card-body text-center pt-5 pb-5 text-start">
					<p class="text-center">
						<strong
							>{$format("page.register.request_denied")}</strong
						>
					</p>
				</div>
			{/if}
		</div>
	</div>
</section>

<style>
	.logo-img {
		margin-top: 4px !important;
		height: 48px !important;
		max-width: 176px !important;
	}

	.card {
		font-size: 1.5em;
		align-self: center;
		flex: 1;
		max-height: 410px;
	}

	.card-body {
		display: flex;
		flex-direction: column;
		align-content: center;
		align-items: center;
		justify-content: center;
	}

	section {
		min-height: 100vh;
		display: flex !important;
		flex-direction: row;
		justify-content: center;
		padding: 0 !important;
		margin: 0 !important;
	}
</style>

